import { render } from "./OrgChartComponent.vue?vue&type=template&id=7281d13c&scoped=true"
import script from "./OrgChartComponent.vue?vue&type=script&lang=js"
export * from "./OrgChartComponent.vue?vue&type=script&lang=js"

import "./OrgChartComponent.vue?vue&type=style&index=0&id=7281d13c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7281d13c"]])

export default __exports__